<div class="img-upload-container">
  <div class="img-upload-wrapper">
    <div class="upload-container" (drop)="onDrop($event)">
      <input type="file" #fileInput id="fileInput" multiple (change)="fileBrowseHandler($event)" />
      <nb-icon class="icon" icon="upload-screen" pack="icomoon"></nb-icon>
      <h4 class="title fontsize16 font500">{{'view_translations.choose_photo_and_upload' | translate}}</h4>
      <div class="desc fontsize16 font500">
        <span class="first">{{'view_translations.max_img_size_5' | translate}}</span>
        <span>{{'view_translations.drag_here_or_upload' | translate}}</span>
      </div>
      <div class="secondary-btn">
        <app-secondary-button
          [iconSize]="12"
          [icon]="'image'"
          [text]="'header_image'"
          [largeButton]="false"
          [backgroundColor]="'grey'"
          (click)="fileInput.click()">
        </app-secondary-button>
      </div>
    </div>
    <div class="images">
      <div class="single-img" *ngFor="let img of uploadedImg">
        <app-single-img [imgFile]="img" (removeImg)="onRemoveImg($event)"></app-single-img>
      </div>
    </div>
    <div class="error-text">
      <small id="errorImgInputContainer" *ngIf="submitted && required && (uploadedImg?.length ?? 0) < (numberOfRequiredImg ?? 0)" class="form-text text-danger">
        {{ 'view_translations.min_number_of_photos' + ' ' + numberOfRequiredImg | translate}}
      </small>
      <small id="errorImgInputContainer" *ngIf="fileSizeError" class="form-text text-danger"> {{ 'view_translations.max_img_size_5' | translate}} </small>
      <small id="errorImgInputContainer" *ngIf="fileTypeError" class="form-text text-danger"> {{ 'view_translations.format_types' | translate}} </small>
    </div>
  </div>
</div>
